export default ({ style }) => (
	<svg
		id="Layer_3"
		data-name="Layer 3"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 27 27"
	>
		<path
			style={style}
			className="cls-1"
			d="M4.691,12.3h.456v6.149a.251.251,0,0,0,.25.25H21.65a.25.25,0,0,0,.25-.25V13.923h.456a.25.25,0,0,0,.25-.25V12.052a.25.25,0,0,0-.25-.25H16.482V9.122h.456a.25.25,0,0,0,.25-.25V7.251a.25.25,0,0,0-.25-.25H10.109a.251.251,0,0,0-.25.25V8.872a.251.251,0,0,0,.25.25h.456v1.059H4.691a.251.251,0,0,0-.25.25v1.621A.251.251,0,0,0,4.691,12.3Zm.956,0h4.918v5.9H5.647ZM21.4,18.2H16.482V13.923H21.4Zm.706-5.9v1.121H16.482V12.3ZM10.359,7.5h6.329V8.622H10.359Zm5.623,1.621V18.2H11.065V9.122ZM4.941,10.681h5.624V11.8H4.941Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M22.846,19.5H4.154a.25.25,0,0,0,0,.5H22.846a.25.25,0,0,0,0-.5Z"
		/>
	</svg>
)
